/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPersonalizedAdsStateRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {GetPersonalizedAdsStateResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const getPersonalizedAdsState = (request:GetPersonalizedAdsStateRequest, options?: CashRequestOptions) => post<GetPersonalizedAdsStateRequest, GetPersonalizedAdsStateResponse>("/cash-app/cash-plato/get-personalized-ads-state", request, {...options, rejectOnError: true })